import React from 'react';
import { Link } from 'react-router-dom';
import './vertical-button.css';

function Vertical() {

  
  return (
    <div className="body-donate">
<a href="/payment">
    <div className="feedback-button">
      <div className="shine"></div>
      <span>Get Registered</span>
    </div>
</a>

    </div>
  );
}

export default Vertical;


